<template>
  <v-text-field 
    :value="value"
    :rules="rules"
    :disabled="disabled"
    :placeholder="placeholder"
    :label="label"
    :solo="solo" 
    :hide-details="hideDetails"
    :error-messages="errorMessages"
    :readonly="readonly"
    dense
    flat  
    outlined 
    required
    @input="$emit('input', $event)"
    @change="$emit('change')" 
    @keydown="keydownMethodString"
    @paste.prevent
  /> 
</template>

<script> 
import { textfieldMix } from '@/mixins/TextField'
const regText = eval('/[=+*@.A-Za-z0-9ก-๙เ_-]+/')

export default { 
  mixins:[textfieldMix],
  methods : {
    keydownMethodString (e) { 
      if (e.key&&!e.key.match(regText)&&e.keyCode!==8) {
        e.preventDefault();
        return
      }

      this.$emit('keydown',e)
    }
  }
}
</script>